export default __webpack_public_path__ + "static/media/factionless_2.42eeebb8.webp";